import { render, staticRenderFns } from "./BadgeInputs.vue?vue&type=template&id=5aff3cda&"
import script from "./BadgeInputs.vue?vue&type=script&lang=ts&"
export * from "./BadgeInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports